import React from 'react';
import RoundButton from '@Components/UI/Buttons/RoundButton';
import { Icon } from '@mui/material';
import { useHistory } from 'react-router-dom';

type Props = {} & React.ComponentProps<typeof RoundButton>;
const AddNewsFeedButton: React.FC<Props> = ({ ...props }) => {
	const histroy = useHistory();

	return (
		<RoundButton
			edcolor="purple"
			onClick={() => histroy.push('/dashboard/newsfeed/create/newsfeed#info')}
			startIcon={<Icon>add</Icon>}
			variant="contained"
			{...props}
		>
			Add NewsFeed
		</RoundButton>
	);
};

export default AddNewsFeedButton;
